import {
    Directive,
    Input,
    OnInit,
    OnDestroy
} from '@angular/core';

import { Subject } from 'rxjs';
import { tap, map, takeUntil } from 'rxjs/operators';

import { RoomComponent } from '../ui.module/room.component';

import { LocalStorageService, SocketService as SocketServiceLegacy } from '../core/upgraded-providers';
import SocketService, { socketServiceFabric } from '../shared-services.module/socket.service';

@Directive({
    selector: '[appUserRoomObjects]'
})
export class UserRoomObjectsDirective implements OnInit, OnDestroy {
    _destroySbj: Subject<void> = new Subject();

    @Input() user: IUser;

    _shard: string;
    @Input() set shard(shard: string) {
        this._shard = shard;
    }

    _room: string;
    @Input() set appUserRoomObjects(room: string) {
        this._room = room;
    }

    _socketSrv: SocketService;
    constructor(
        private _roomRef: RoomComponent,

        private _socketLegacySrv: SocketServiceLegacy,
        private _localStorageSrv: LocalStorageService
    ) {
    }

    ngOnInit() {
        const url = this._socketLegacySrv.options.websocketUrl;
        const token = this._localStorageSrv.get('auth', null, '');

        this._socketSrv = socketServiceFabric({ url, token });
        this._socketSrv.on(`roomMap2:${ this._shard }/${ this._room }`)
            .pipe(takeUntil(this._destroySbj))
            .pipe(map(({ data: [, objects]}) => objects))
            .pipe(tap((objects) => this._roomRef.drawObjects(objects, {
                [this.user._id]: new Uint8ClampedArray([0, 255, 0])
            })))
            .subscribe();
    }

    ngOnDestroy() {
        this._destroySbj.next();
        this._destroySbj.complete();

        this._socketSrv.off(`roomMap2:${ this._shard }/${ this._room }`)
    }

}
